import cx from 'classnames';
import PropTypes from 'prop-types';
import { CloudinaryPicture } from '@bwoty-web/ui-kit';
import { useState, useEffect } from 'react';

import LoaderHeading from './LoaderHeading';
import { getCloudinaryUrl } from '../../../utils/imageUtils';

import './galleryLoader.scss';

const GalleryLoader = ({ heading = null, imageList = [], isPackagePlus = false, siteSettings, tips = [] }) => {
  const [imageCount, setImageCount] = useState(0);
  const [tipCount, setTipCount] = useState(0);

  useEffect(() => {
    const timerId = setInterval(() => {
      setImageCount(imageCount + 1);
    }, 3000);

    return () => clearInterval(timerId);
  }, [imageCount]);

  useEffect(() => {
    const timerId = setInterval(() => {
      setTipCount(tipCount + 1);
    }, 4500);

    return () => clearInterval(timerId);
  }, [tipCount]);

  const filteredImages = imageList.filter((img) => img.width > img.height);

  const imageComponents = filteredImages.map((img, index) => {
    const position = index - (imageCount % filteredImages.length);
    const cloudinaryUrl = getCloudinaryUrl(siteSettings.imageDomain, img.relativeUrl, img.height, img.width);

    return (
      <div
        key={index}
        className={cx('iw-gallery-loader__picture-wrapper', {
          'iw-gallery-loader__picture-wrapper--current': position === 0,
          'iw-gallery-loader__picture-wrapper--prev': position === -1 || position === filteredImages.length - 1,
          'iw-gallery-loader__picture-wrapper--next':
            position === 1 || position === -Math.abs(filteredImages.length - 1),
        })}
      >
        {img.text && <div className="iw-gallery-loader__picture-text">{img.text}</div>}
        <CloudinaryPicture
          alt={img.text || 'hotel-text'}
          img={{
            cloudinaryUriTemplate: cloudinaryUrl,
            size: {
              width: img.width,
              height: img.height,
            },
          }}
          sizes={[
            { height: 300, width: 450, breakpoint: 768 },
            { height: 220, width: 360 },
          ]}
        />
      </div>
    );
  });

  return (
    <div
      className={cx('iw-gallery-loader', {
        'iw-gallery-loader--no-gallery': !imageList || imageList?.length <= 0,
      })}
    >
      <LoaderHeading heading={heading} />
      <div className="iw-gallery-loader__gallery">{imageComponents}</div>
      {!isPackagePlus && (
        <div className="iw-gallery-loader__tips">
          {tips.map((tip, index) => {
            const position = index - (tipCount % tips.length);
            return (
              <div
                className={cx('iw-gallery-loader__tip', {
                  'iw-gallery-loader__tip--current': position === 0,
                })}
                key={index}
              >
                <span>{tip.heading}</span>
                <p>{tip.text}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

GalleryLoader.propTypes = {
  heading: PropTypes.string,
  imageList: PropTypes.arrayOf(PropTypes.shape({})),
  isPackagePlus: PropTypes.bool,
  siteSettings: PropTypes.shape({ imageDomain: PropTypes.string }).isRequired,
  tips: PropTypes.arrayOf(PropTypes.shape({})),
};

export default GalleryLoader;
